import React from 'react'
import { useTranslation } from 'react-i18next'
import { Typogaphy } from 'vnetwork-ui'

interface AnalyticCardProps {
    title: string | number
    subtitle: string
    icon: React.ReactElement
    replaceSpace?: string
    text: { prefix: string; suffix: string | number }[]
}

const AnalyticCard: React.FC<AnalyticCardProps> = ({
    title,
    subtitle,
    icon,
    replaceSpace,
    text,
}) => {
    const { t } = useTranslation()
    return (
        <div className="bg-white rounded-[8px] p-4 col-span-1">
            <div className="flex justify-between items-center">
                <div>
                    <Typogaphy className="text-2xl font-semibold text-gray-900">
                        {title}
                    </Typogaphy>
                    <p className="text-gray-500 text-sm mt-1">{t(subtitle)}</p>
                </div>
                <div className="text-blue-600 w-8 h-8">{icon}</div>
            </div>
            <div className="bg-gray-50 mt-4 px-2 py-4 rounded-sm flex gap-1">
                {text &&
                    text?.map((text, index) => (
                        <React.Fragment key={index}>
                            <Typogaphy className="text-sm text-gray-500">
                                {t(text.prefix)}
                                {!replaceSpace ? ' : ' : ` ${replaceSpace} `}
                            </Typogaphy>
                            <Typogaphy className="text-sm font-medium text-primary capitalize">
                                {text.suffix}
                            </Typogaphy>
                        </React.Fragment>
                    ))}
            </div>
        </div>
    )
}

export default AnalyticCard
